import { Link } from "react-router-dom";

interface ConsentCheckboxesProps {
  consent: boolean;
  onConsentChange: (checked: boolean) => void;
  variant?: "light" | "dark";
  // Legacy props for backward compatibility
  nonMarketingConsent?: boolean;
  marketingConsent?: boolean;
  onNonMarketingChange?: (checked: boolean) => void;
  onMarketingChange?: (checked: boolean) => void;
}

export const ConsentCheckboxes = ({
  consent,
  onConsentChange,
  variant = "light"
}: ConsentCheckboxesProps) => {
  const textColorClass = variant === "dark" ? "text-gray-200" : "text-muted-foreground";
  const linkColorClass = variant === "dark" ? "text-primary hover:text-primary/80" : "text-primary hover:underline";
  const checkboxClass = variant === "dark" 
    ? "h-4 w-4 mt-0.5 rounded border-primary/50 bg-[#0a1128] text-primary focus:ring-primary flex-shrink-0"
    : "h-4 w-4 mt-0.5 rounded border-border text-primary focus:ring-primary flex-shrink-0";

  return (
    <div className="space-y-4">
      <div className="flex items-start space-x-3">
        <input
          type="checkbox"
          id="smsConsent"
          checked={consent}
          onChange={(e) => onConsentChange(e.target.checked)}
          required
          className={checkboxClass}
        />
        <label htmlFor="smsConsent" className={`text-xs ${textColorClass} cursor-pointer leading-relaxed`}>
          I consent to receive informational and marketing text messages from MuxSignal at the number provided regarding service availability, account updates, and promotional offers. Message frequency varies. Message and data rates may apply. Text HELP for assistance. Reply STOP to opt out.
        </label>
      </div>

      {/* Legal Links */}
      <div className="flex items-center justify-center gap-1 text-sm">
        <Link to="/privacy-policy" className={linkColorClass}>
          Privacy Policy
        </Link>
        <span className={textColorClass}>|</span>
        <Link to="/terms-of-service" className={linkColorClass}>
          Terms of Service
        </Link>
      </div>
    </div>
  );
};
